import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AsideService {

  isAsideMinimised = new BehaviorSubject<boolean>(false);

  constructor() { }
}
